import { Button, Center, Flex, Stack, Text } from "@chakra-ui/react";
import useGetUserInfo from "core/features/auth/hooks/useGetUserInfo";
import colors from "core/resources/theme/colors";
import { Moment } from "moment";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { BiChevronLeft } from "react-icons/bi";
import { MdArrowForward } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import OutlineButton from "ui/components/Button/OutlineButton";
import Container from "ui/components/Layout/Container";
import BarStep from "./components/BarStep";
import DataVisita from "./components/DataVisita";
import useCurrentStep from "./hooks/useCurrentStep";
import { useIngressosStore } from "./hooks/useIngressosStore";
import useStepTitle from "./hooks/useStepTitle";

function DataPasseio() {
  const { control, getValues, trigger } = useForm<{
    dataVisita: string;
    calendarioId: string;
  }>();
  const { data: user } = useGetUserInfo();

  const activeStep = useCurrentStep();
  const [titleStep, titleNextStep] = useStepTitle(activeStep, activeStep + 1);

  const navigate = useNavigate();

  useEffect(() => {
    if (!!user && !user.cpf) {
      const instance = Swal.fire({
        title: "CPF não informado",
        confirmButtonText: "Ir para meus dados",
        icon: "warning",
        text: "É necessario ter o CPF informado nas informações do usuário para adquirir ingressos.",
      });

      instance.then(({ isConfirmed }) => {
        if (isConfirmed) {
          setTimeout(() => {
            navigate("/perfil");
          }, 250);
        }
      });
    }
  }, [user, navigate]);

  return (
    <Container>
      <Flex flexDir="column">
        <Flex
          pt={["130px", "130px", "130px", "330px"]}
          mb="80px"
          flexDir={"column"}
          gap={8}
        >
          <BarStep
            step={activeStep}
            titleNextStep={titleNextStep!}
            nextStep={activeStep + 1}
            titleStep={titleStep!}
          />

          <Stack spacing={2}>
            <Text
              fontWeight="medium"
              fontSize="28px"
              color={colors.purple500}
              flexWrap="wrap"
            >
              {"Escolha um dia para sua Diversão"}
            </Text>
            <Text fontSize="20px">
              {
                "Os valores apresentados no calendário representam o valor dinâmico do ingresso adulto, podendo sofre alterações a qualquer momento. Garanta já o seu !"
              }
            </Text>
          </Stack>

          <Flex gap={8} flexDir={["column", "column", "row"]}>
            <DataVisita
              control={control}
              onChangeDiaUtil={(diaUtil) => {
                useIngressosStore.getState().setDiaUtilSelecionado(diaUtil);
                useIngressosStore.getState().setEventoId(undefined);
                diaUtil &&
                  useIngressosStore
                    .getState()
                    .setCalendarioId(diaUtil?.calendarioId);
              }}
            />
          </Flex>

          <Flex justify="space-between" align="center" mt={12}>
            <OutlineButton
              title="VOLTAR"
              color={colors.blue}
              prevIcon={<BiChevronLeft size={20} />}
              onClick={() => {
                navigate(-1);
              }}
            />

            <OutlineButton
              title="PRÓXIMO"
              color={colors.white}
              bg={colors.newBlue}
              bgBorder={colors.newBlue}
              nextIcon={<MdArrowForward size={20} />}
              onClick={async () => {
                const isValid = await trigger();
                if (!isValid) return;

                useIngressosStore
                  .getState()
                  .setDataSelecionada(
                    (getValues("dataVisita") as unknown as Moment).toISOString()
                  );

                navigate(
                  `/ingresso/${useIngressosStore.getState().calendarioId}`
                );
              }}
            />
          </Flex>

          <Center>
            <Button
              variant="link"
              color={colors.blue500}
              mt={8}
              onClick={() => {
                navigate(`/ingresso`);
              }}
            >
              Confira outros eventos
            </Button>
          </Center>
        </Flex>
      </Flex>
    </Container>
  );
}

export const fmtReal = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
}).format;

export default DataPasseio;
